import * as types from './types'
import storage from '@/plugins/storage'
import globals from '@/plugins/globals'
export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.ADAS_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.ADAS_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.ADAS_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.ADAS_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.ADAS_FILTER_BY, filterBy)
  },
  [types.INIT_ADAS](state) {
    state.highlightSave = false
    state.adas = JSON.parse(JSON.stringify(state.default))
  },
  [types.INIT_ADASINSPECTION](state) {
    state.requests = []
    state.request = null
    state.highlightSave = false
    state.adasInspection = JSON.parse(JSON.stringify(state.defaultInspection))
  },
  [types.SET_ADAS](state, data) {
    state.adas = data
  },
  [types.SET_ADASS](state, data) {
    state.adass = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adass = data
      }
    }
  },
  [types.UPDATE_ADAS](state, data) {
    if (state.adas !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.adas.firm = parseInt(data.value)
          state.adas.vehicle.firm = parseInt(data.value)
          break
        case 'adas':
          state.adas.adas = parseInt(data.value)
          break
        case 'adasType':
          state.adas.adasType = parseInt(data.value)
          break
        case 'insurance':
          state.adas.insurance = parseInt(data.value)
          break
        case 'ronumber':
          state.adas.ronumber = data.value
          break
        case 'vehicleYear':
          state.adas.vehicle.year = parseInt(data.value)
          break
        case 'vehicleMake':
          state.adas.vehicle.makeId = data.value
          state.adas.vehicle.make = data.value
          break
        case 'vehicleModel':
          state.adas.vehicle.model = data.value
          break
        case 'vehicleVin':
          state.adas.vehicle.vin = data.value
          break
        case 'createdBy':
          state.adas.createdBy = data.value
          break
        case 'notes':
          state.adas.notes = data.value
          break
        case 'status':
          state.adas.status = parseInt(data.value)
          break
      }
    }
  },
  [types.SET_ADASINSPECTIONS](state, data) {
    state.adasInspections = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasInspections = data
      }
    }
  },
  [types.SET_ADASINSPECTION](state, data) {
    state.adasInspection = data
  },
  [types.UPDATE_ADASINSPECTION](state, data) {
    if (state.adasInspection !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.adasInspection.firm = parseInt(data.value)
          break
        case 'adas':
          state.adasInspection.adas = parseInt(data.value)
          break
        case 'inspectionType':
          state.adasInspection.adasInspectionType = parseInt(data.value)
          break
        case 'inspector':
          state.adasInspection.inspector = parseInt(data.value)
          break
        case 'insurance':
          state.adasInspection.insurance = parseInt(data.value)
          state.adasInspection.insuranceName = data.extra
          break
        case 'ronumber':
          state.adasInspection.ronumber = data.value
          break
        case 'notes':
          state.adasInspection.notes = data.value
          break
        case 'status':
          state.adasInspection.status = data.value
          break
        case 'inspectionDate':
          state.adasInspection.inspectionDate = data.value
          break
      }
    }
    let foundInspection = state.adasInspections.find((x) => parseInt(x.adasInspection) === parseInt(state.adasInspection.adasInspection))
    if (foundInspection !== undefined && foundInspection !== null) {
      foundInspection.ronumber = state.adasInspection.ronumber
      foundInspection.insurance = state.adasInspection.insuranceName
      foundInspection.inspector = state.adasInspection.inspectorName
    }
    console.log('Update Inspection', { data: data, inspection: state.adasInspection })
  },
  [types.UPDATE_ADAS_INSPECTION_RECORD](state, data) {
    let foundInspection = state.adasInspections.find((x) => parseInt(x.adasInspection) === parseInt(data.adasInspection))
    if (foundInspection !== undefined && foundInspection !== null) {
      foundInspection.ronumber = data.ronumber
      foundInspection.insurance = data.insuranceName
      foundInspection.inspector = data.inspectorName
    }
  },
  [types.SET_ADAS_STATUS](state, data) {
    state.adas.status = data.status
  },
  [types.SET_ADAS_INSPECTION_STATUS](state, data) {
    state.adasInspection.status = data.status
    let foundInspection = state.adasInspections.find((x) => parseInt(x.adasInspection) === parseInt(data.adasInspection))
    if (foundInspection !== undefined && foundInspection !== null) {
      if (parseInt(data.status) === 2) {
        foundInspection.status = 2
        foundInspection.statusName = 'Complete'
        let foundInspections = state.adasInspections.filter((x) => parseInt(x.adas) === parseInt(foundInspection.adas))
        if (foundInspections !== undefined && foundInspections !== null) {
          let isComplete = true
          foundInspections.forEach((element) => {
            if (element.statusName !== 'Complete') {
              isComplete = false
            }
          })
          if (isComplete) {
            let foundAdas = state.adass.items.find((x) => parseInt(x.adas) === parseInt(foundInspection.adas))
            if (foundAdas !== undefined && foundAdas !== null) {
              foundAdas.status = 2
              foundAdas.statusName = 'Complete'
            }
          }
        }
      }
    }
  },
  [types.SET_ADASINSPECTIONRESULTS](state, data) {
    state.adasInspectionResults = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasInspectionResults = data
      }
    }
  },
  [types.SET_REPAIRLINES](state, data) {
    state.repairlines = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.repairlines = data
      }
    }
    console.log('Got Repair Lines', state.repairlines)
  },
  [types.SET_REPORTPREFERENCE](state, data) {
    state.reportPreference = data
  },
  [types.SET_ADAS_RESET](state, data) {
    state.adasDecodeInfo = data
  },
  [types.SET_LINKS](state, data) {
    state.links = data
    try {
      if (data) {
        if (Array.isArray(data)) {
          data.forEach((element) => {
            if (element.links) {
              if (element.links !== null) {
                try {
                  element.links = JSON.parse(element.links)
                } catch (e) {
                  element.links = []
                }
              }
            }
          })
        } else {
          state.links = data
          if (state.links.links) {
            if (state.links.links !== null) {
              try {
                state.links.links = JSON.parse(state.links.links)
              } catch (e) {
                state.links.links = []
              }
            }
          }
        }
      }
    } catch (e) {
      console.log('Error (adas > mutations > Set Links)', e)
    }
    console.log('Got Links', state.links)
  },
  [types.SET_DECODED](state, data) {
    state.decoded = []
    if (data) {
      if (data !== '') {
        state.decoded = data
      }
    }
  },
  [types.SET_EQUIPPED](state, data) {
    let found = state.repairlines.find((x) => x.lineNum === data.lineNum && x.uniqueSequenceNumber === data.uniqueSequenceNumber)
    if (found) {
      found.isNotEquipped = data.isNotEquipped
      console.log('equipped', found)
    }
  },
  [types.SET_RESULT_EQUIPPED](state, data) {
    let found = state.adasInspection.results.find((x) => x.adasInspectionResult === data.adasInspectionResult)
    if (found) {
      found.isNotEquipped = data.isNotEquipped
      console.log('result equipped', found)
    }
  },
  [types.RESET_REQUESTS](state) {
    state.requests = []
  },
  [types.RESET_REQUEST](state) {
    state.request = null
  },
  [types.SET_REQUESTS](state, data) {
    state.requests = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.requests = data
      }
    }
    console.log('Got Requests', state.requests)
    if (state.request !== null) {
      let found = state.requests.find((element) => parseInt(element.opportunity) === parseInt(state.request.opportunity))
      if (found) {
        state.request = JSON.parse(JSON.stringify(found))
        if (state.request.lines) {
          if (globals.isParsedJson(state.request.lines) === false) {
            state.request.lines = JSON.parse(state.request.lines)
          }
        }
        if (state.request.notes) {
          if (globals.isParsedJson(state.request.notes) === false) {
            state.request.notes = JSON.parse(state.request.notes)
          }
        }
        if (state.request.technicians) {
          if (globals.isParsedJson(state.request.technicians) === false) {
            state.request.technicians = JSON.parse(state.request.technicians)
          }
        }
        if (state.request.files) {
          if (globals.isParsedJson(state.request.files) === false) {
            state.request.files = JSON.parse(state.request.files)
          }
        }
      }
    }
  },
  [types.SET_REQUEST](state, data) {
    switch (data.name) {
      case 'statusName':
        state.request.statusName = data.value
        break
      case 'reason':
        state.request.reason = data.value
        break
      case 'reasonSource':
        state.request.reasonSource = data.value
        break
      case 'request': {
        state.request = null
        if (state.requests) {
          let found = state.requests.find((element) => parseInt(element.opportunity) === parseInt(data.value))
          if (found) {
            state.request = JSON.parse(JSON.stringify(found))
            if (state.request.lines) {
              if (globals.isParsedJson(state.request.lines) === false) {
                state.request.lines = JSON.parse(state.request.lines)
              }
            }
            if (state.request.notes) {
              if (globals.isParsedJson(state.request.notes) === false) {
                state.request.notes = JSON.parse(state.request.notes)
              }
            }
            if (state.request.technicians) {
              if (globals.isParsedJson(state.request.technicians) === false) {
                state.request.technicians = JSON.parse(state.request.technicians)
              }
            }
            if (state.request.files) {
              if (globals.isParsedJson(state.request.files) === false) {
                state.request.files = JSON.parse(state.request.files)
              }
            }
          }
        }
        break
      }
    }
    console.log('Set Request', state.request)
  },
  [types.SET_REQUEST_NOTES](state, data) {
    state.request.notes = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        if (globals.isParsedJson(data) === false) {
          state.request.notes = JSON.parse(data)
        } else {
          state.request.notes = data
        }
      }
    }
  },
  [types.SET_ADASINSPECTION_NOT_INSTALLED](state, data) {
    console.log('adasNotInstalled mutations received:', data)
    state.adasNotInstalled = []
    if (data !== undefined && data !== null) {
      state.adasNotInstalled = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/mutations.js